import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M10.42 6.89a.88.88 0 0 0 .874-.888.88.88 0 0 0-.874-.89.88.88 0 0 0-.873.89c0 .49.39.889.873.889" }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.25 2.811c-.99-.056-1.981.101-2.908.461s-1.77.917-2.473 1.633A7.2 7.2 0 0 0 4.3 7.335a7.33 7.33 0 0 0 .158 5.701 7.2 7.2 0 0 0 1.7 2.335 7 7 0 0 0 2.463 1.457 6.93 6.93 0 0 0 5.555-.471 7 7 0 0 0 1.735-1.326l-4.39-4.468a.8.8 0 0 1 0-1.121l4.39-4.468a7 7 0 0 0-1.822-1.375 7 7 0 0 0-2.84-.788m-3.488-1.03a8.54 8.54 0 0 1 7.072.401 8.7 8.7 0 0 1 2.795 2.333.8.8 0 0 1-.059 1.054l-4.357 4.434 4.358 4.433a.8.8 0 0 1 .058 1.055 8.7 8.7 0 0 1-2.69 2.272 8.53 8.53 0 0 1-6.834.58 8.6 8.6 0 0 1-3.023-1.789A8.8 8.8 0 0 1 3.003 13.7a8.92 8.92 0 0 1-.193-6.947 8.8 8.8 0 0 1 1.917-2.969A8.65 8.65 0 0 1 7.762 1.78m2.658 4.131c-.027 0-.073.027-.073.09 0 .062.046.089.073.089s.073-.027.073-.09c0-.062-.046-.089-.073-.089m-1.673.09c0-.92.735-1.69 1.673-1.69s1.674.77 1.674 1.69-.736 1.689-1.674 1.689S8.747 6.92 8.747 6",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }